import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { FormWidgetAvvModule } from '@modules/bcm/@work-flows/@form-widgets/core/avv/form-widget-avv.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReadPrivacyAndConditionsComponent } from '@modules/bcm/@work-flows/read-privacy-and-conditions/read-privacy-and-conditions.component';

@NgModule({
    declarations: [ReadPrivacyAndConditionsComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        DragDropModule,
        FlexModule,

        MatToolbarModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,

        FormWidgetAvvModule,
        MatDividerModule,
        MatProgressSpinnerModule,
    ],
    exports: [ReadPrivacyAndConditionsComponent]
})
export class ReadPrivacyAndConditionsModule {

}
